import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16e2a8d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-fixed-aside" }

import BaseFixedAsideElement from '@/components/aside/BaseFixedAsideElement.vue';
import AsideItems from '@/data/AsideItems';

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseFixedAside',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(AsideItems), (item, index) => {
      return (_openBlock(), _createBlock(BaseFixedAsideElement, _mergeProps({
        key: `fs-item-${index}`
      }, item), null, 16))
    }), 128))
  ]))
}
}

})